import RelationshipMetadata from "../../RelationshipMetadata";

class DeveloperSubscriptionDeveloperSubscriptionCommunicationRelationshipMetadata extends RelationshipMetadata {
    constructor() {
        super();

        this.name = "DeveloperSubscriptionDeveloperSubscriptionCommunicationRelationshipMetadata";
        this.parentEnterpriseComponent = "DeveloperSubscription";
        this.childEnterpriseComponent = "DeveloperSubscriptionCommunication";
        this.sourceAttribute = "USID";
        this.destinationAttribute = "DeveloperSubscriptionUSID";
    }
}

export default DeveloperSubscriptionDeveloperSubscriptionCommunicationRelationshipMetadata;